import React from 'react';

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    position: 'absolute',
    width: '100%',
    zIndex: '1000',
  },
}));

export default ({ show, background, zIndex }) => {
  const classes = useStyles();

  const stylesSetup = {
    background: background || '#FFFFFF',
    display: show ? 'block' : 'none',
    zIndex: zIndex || 1000,
  };

  return <div className={classes.container} style={stylesSetup} />;
};
